import { css } from "styled-components";
import { CardImage, CardTitle, CardBody, CardDescription } from "../../../..";
export const riotProductSkin = (chroma) => css `
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  position: relative;
  align-items: flex-start;

  * {
    position: relative;
  }

  .icon-action-play-video {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%) scale(1);
    transition: transform 0.2s ease-in-out;
    ${chroma.mediaQueries.tabletDown} {
      width: 55px;
      height: 55px;
    }
  }

  &:hover {
    .icon-action-play-video {
      transform: translate(-50%, -50%) scale(1.15);
    }
  }

  ${CardImage} {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;

    img {
      width: 100%;
      height: 100%;
    }
  }

  .icon-link {
    position: absolute;
    top: 10px;
    right: 10px;
    ${chroma.typography.display9};
  }

  ${CardBody} {
    width: 100%;
    padding: 0 14px 12px 14px;
    background: linear-gradient(0deg, rgb(0 0 0 / 75%), rgb(0 0 0 / 55%) 50%, transparent);
    ${CardTitle} {
      ${chroma.typography.display9};
      display: -webkit-box;
      color: white;
      text-shadow: 0 3px 3px rgb(0 0 0 / 50%);
      overflow: hidden;
      text-overflow: ellipsis;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
    }
    ${CardDescription} {
      color: white;
    }
  }
`;
//# sourceMappingURL=index.js.map